import React from 'react'
import { DYNAMIC_PRICING_CATEGORY } from 'common/constants'
import MarketVIPIcon from './MarketVIPIcon'
import HighrisesIcon from './HighrisesIcon'

const DynamicPricingIcon = ({ type, ...passProps }) => {
  switch(type) {
    case DYNAMIC_PRICING_CATEGORY.TRANSITION:
    case DYNAMIC_PRICING_CATEGORY.MARKET_VIP:  // I think this is legacy, can we remove this?
      return <MarketVIPIcon {...passProps} />
    case DYNAMIC_PRICING_CATEGORY.HIGHRISES:
      return <HighrisesIcon {...passProps} />
    case DYNAMIC_PRICING_CATEGORY.STANDARD:
    default:
      return <div />
  }
}

export default DynamicPricingIcon
